import { z } from "zod";

export const storeSchema = () => {
  return z.object({
    company: z.number().min(1),
    active: z.boolean(),
    country: z.string().min(1),
    postal_code: z.string().optional().nullable(),
    state: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    neighborhood: z.string().optional().nullable(),
    street: z.string().optional().nullable(),
    number: z.string().optional().nullable(),
  });
};

export type StoreFormValues = z.infer<ReturnType<typeof storeSchema>>;
